import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { EServices } from "@/types";
import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import VEmptyState from "@/vuetify-extensions/VEmptyState.vue";

import { datetime } from "@/utils/time";
import { Mixins, Component, Inject } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { IActivity } from "../../types";
import NetworkErrorImage from "@/components/NetworkErrorImage.vue";
import SecurityClient from "../../services/SecurityClient";

const SecurityModule = namespace("SecurityModule");

@Component({
  components: {
    VEmptyState,
    NetworkErrorImage,
  },
})
export default class Activities extends Mixins(JackocoinsNetworkManagerMixin) {
  @Inject(EServices.security)
  securityClient!: SecurityClient;

  @SecurityModule.State
  activities!: IActivity[];

  datetime = datetime;

  @throwsNetworkError()
  async getActivities() {
    await this.securityClient.getActivities();
  }

  mounted() {
    this.getActivities();
  }
}
